<template>
  <div class="">
    <el-card class="box-card">
      <div class="search-form" style="text-align: left">
        <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="100px" label-position="left"
          class="demo-form-inline" size="small">
          <el-form-item :label="$t('ltladdress.list.contactPerson')" label-width="60px">
            <el-input clearable size="small" v-model="searchForm.userName" :placeholder="$t('ltladdress.list.pleaseEnterContactPerson')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ltladdress.list.addressType')" label-width="70px">
            <el-select v-model="searchForm.addressFunction" :placeholder="$t('ltladdress.list.pleaseSelectAddressType')">
              <el-option :label="$t('ltladdress.list.shippingAddress')" value="0"></el-option>
              <el-option :label="$t('ltladdress.list.receivingAddress')" value="1"></el-option>
            </el-select>
          </el-form-item>          
          <el-form-item :label="$t('ltladdress.list.contactPhone')" label-width="70px">
            <el-input clearable size="small" v-model="searchForm.phone" :placeholder="$t('ltladdress.list.pleaseEnterContactPhone')"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('ltladdress.list.search') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('ltladdress.list.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="" style="margin-bottom: 15px;text-align:left">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">{{ $t('ltladdress.list.addAddress') }}</el-button>
      </div>
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('ltladdress.list.serialNo')" width="60"></el-table-column>
        <el-table-column prop="addressName" :label="$t('ltladdress.list.addressName')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address1" :label="$t('ltladdress.list.address')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="province" :label="$t('ltladdress.list.shippingReceivingPlace')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.addressFunction == 0 ? $t('ltladdress.list.shippingAddress') : $t('ltladdress.list.receivingAddress')}}
          </template>
        </el-table-column>
        <el-table-column prop="city" :label="$t('ltladdress.list.addressType')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.addressFunction == 0 ? $t('ltladdress.list.shippingAddress') : $t('ltladdress.list.receivingAddress')}}
          </template>
        </el-table-column>
        <el-table-column prop="userName" :label="$t('ltladdress.list.contactPerson')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" :label="$t('ltladdress.list.contactPhone')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" :label="$t('ltladdress.list.contactEmail')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isDefault" :label="$t('ltladdress.list.isDefault')" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.isDefault == 0 ? $t('ltladdress.list.yes') : $t('ltladdress.list.no')}}
          </template>
        </el-table-column>
        <el-table-column prop="action" :label="$t('ltladdress.list.operation')" width="140">
          <template slot-scope="scope">
            <div>
              <span style="color: #409eff; cursor: pointer" @click="handleEdit(scope.row)">{{ $t('ltladdress.list.modify') }}</span>
              <el-divider direction="vertical"></el-divider>
              <span style="color: #f40000; cursor: pointer" @click="handleDel(scope.row)">{{ $t('ltladdress.list.delete') }}</span>
              <el-divider direction="vertical" v-if="isType"></el-divider>
              <span style="color: #B2AE10; cursor: pointer" @click="handleSelect(scope.row)" v-if="isType">{{ $t('ltladdress.list.select') }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization
          :background="true"
          :currentPage="current"
          :total="total"
          :pageSize="size"
          @current-change="currentChange"
        />
      </div>
    </el-card>

    <!-- 表单弹窗 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="title"
      append-to-body
      :visible.sync="formVisible"
      width="1000px"
      :before-close="closeDialog"
    >
      <Form
        ref="formModal"
        :record="record"
        v-if="formVisible"
        @ok="editSuccess"
        append-to-body
      />
    </el-dialog>
  </div>
</template>

<script>
import Form from "./form";
import { list, addressDel } from '@/api/ltl/address'
export default {
  props: {
    isType: {
      type: [Number, String],
      default: ''
    }
  },
  components: {
    Form,
  },
  data() {
    return {
      formVisible: false,
      record: {},
      title: this.$t('ltladdress.list.addAddressTitle'),
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
  mounted(){
    if(this.isType){
      this.searchForm.address_type = this.isType
    }
    this.init()
  },
  methods: {
    // 开关设置默认地址
    // handleChangeDefault(e,id){
    //   defaultUpdate({
    //     user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
    //     address_id: id
    //   }).then(res => {
    //     if(res.code == 1){
    //       this.$message.success(res.msg);
    //       this.init();
    //     }else{
    //       this.$message.success(res.msg);
    //     }
    //   })
    // },
    // 获取列表
    init(){
      list({
        u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
        page: this.current,
        limit: this.size,
        ...this.searchForm
      }).then(res => {
        if(res.code == 1){
          this.dataList = []
          this.dataList = res.data.data
          this.total = res.data.total
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.record = {};
      this.formVisible = false;
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false;
      this.init();  //刷新列表
    },
    //视频监控站点新增
    handleAdd() {
      this.title = this.$t('ltladdress.list.addAddressTitle')
      this.record = {}
      this.formVisible = true
    },
    //视频监控站点修改
    handleEdit(record) {
      this.title = this.$t('ltladdress.list.editAddressTitle')
      this.record = {
        ...record
      }
      this.formVisible = true
    },
    //视频监控站点删除
    handleDel(record) {
      const _that = this;
      this.$confirm(this.$t('ltladdress.list.confirmDelete'), this.$t('ltladdress.list.warmTip'), {
        type: "warning",
      })
        .then(() => {
          addressDel({ 
            u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
            id: record.id 
          }).then(res => {
            if(res.code == 1){
              this.current = 1
              this.$message.success(this.$t('ltladdress.list.deleteSuccess'));
              this.init();
            }else{
              this.$message.error(this.$t('ltladdress.list.deleteFailed'));
            }
          });
        })
        .catch(() => {});
    },
    //新增、修改成功的回调
    editSuccess() {
      this.formVisible = false
      this.init();
    },
    // 选择地址
    handleSelect(scope){
      this.$emit('ok',scope,this.isType)
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.init();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>